export const getters = {
  systemDestinations: state => state.destinations,
  Destination: state => state.systemDestination
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/destinations/getters.js